'use client';

import { Sentry } from '@loamify/observability/react';
import { useEffect, useMemo } from 'react';

function readCspNonceCookie(): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie.match(/(?:^|;\s*)loamify_csp_nonce=([^;]+)/);
  return match?.[1] ? decodeURIComponent(match[1]) : undefined;
}

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const nonce = useMemo(() => readCspNonceCookie(), []);

  useEffect(() => {
    Sentry.captureException(error, {
      tags: { surface: 'web-admin-global-error' },
    });
  }, [error]);

  return (
    <html lang="en" nonce={nonce} suppressHydrationWarning>
      <body>
        <main className="mx-auto flex min-h-screen max-w-lg flex-col justify-center gap-4 p-6">
          <h1 className="text-xl font-semibold">Admin console unavailable</h1>
          <p className="text-sm text-neutral-600">
            The error was recorded without personal data. Try the request again.
          </p>
          <button className="w-fit rounded-md border px-4 py-2" onClick={reset} type="button">
            Try again
          </button>
        </main>
      </body>
    </html>
  );
}
